module.exports = __webpack_public_path__ + "static/media/400407_01.c07823f7.png";